module.exports = __webpack_public_path__ + "static/media/S (188).ade51d16.jpg";